import React from 'react';
import { User } from '../types';

export type ContextProps = {
    profile: User | null;
    setProfile: (value: User) => void;
};

export default React.createContext<ContextProps>({ profile: null, setProfile: () => {} });
